import { createGlobalStyle } from 'styled-components';

const ImgViewerStyles = createGlobalStyle`
    .${(props) => props.wrapperClassName} {
        &.ril-outer {
            background-color: rgba(0, 0, 0, 0.9);
        }
        .ril-toolbar {
            padding: ${({ theme }) => theme.gridGutterWidth}px;
        }
        .ril-toolbar, .ril__toolbarSide {
            height: auto;
        }
        .ril__toolbarSide {
            align-items: center;
            display: inline-flex;
            padding: 0;
        }
        .ril-toolbar-right {
            font-size: 1.8em;
            .ril-toolbar__item {
                display: inline-flex;
                align-items: center;
            }
        }
        .ril-toolbar__item {
            &:not(:only-child) {
                line-height: initial;
                margin-left: ${({ theme }) => 1.2 * theme.gridGutterWidth}px;
            }
            &:only-child {
                margin-left: ${({ theme }) => theme.gridGutterWidth}px;
            }
        }
        .ril__closeButton {
            background-size: 72%;
            height: 1em;
            opacity: 0.4;
            width: 1em;
        }
        .ril-image-current {
            ${'' /* max-width: none !important; */}
            transition: transform .8s ease-in-out;
        }
        .inx-io-icon {
            height: 1.75rem;
            font-size: 1.5rem;
            line-height: 1.75rem;
        }
        .inx-fa-icon {
            height:1.3rem;
            font-size: 120% !important;
        }
        .ico-product {
            height: 1.75rem;
            font-size: 1.5rem;
            line-height: 1.55rem;
        }
        .item-action {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            color: var(--color-white);
            height: auto;
            min-width: 1em;
            opacity: 0.4;
            width: auto;
            &:hover {
                opacity: 1;
            }
        }
        .ril__tooltip {
            line-height: 1;
        }
    }
`;

export default ImgViewerStyles;
